"use client";
import React from "react";
import { Button, Grid } from "semantic-ui-react";
import PropTypes from "prop-types";
import Router from "next/router";
//import {geocodeByAddress, getLatLng} from 'react-places-autocomplete';
import { GoogleMapExample } from "../../../pagecomponents/PresentationalComponent/GoogleMapWrapperCity";
import cookie from "react-cookies";
import axios from "axios";
import { getcitydata } from "../../../modules/Graphql/cityquestionandanswergraphql";
import millify from "millify";
import { Amplify, Auth } from "aws-amplify";
var humanFormat = require("human-format");

// Amplify.configure(CognitoConfig);

class Bottommap extends React.Component {
  centerPt;

  constructor(props) {
    super(props);
    this.map = null;
    this.city_name_map;
    this.state_name_map;
    this.polygon_points = [];
    this.pbermudaTriangle = [];
    this.home_points = [];
    this.citybermudaTrianglesingle = [];
    this.npiscore = [];
    this.homegmarkers = [];
    this.arr = [];
    this.loadrcount = 0;
    this.state = {
      singlehome: [],
      the_message: "",
      fetchschool: [],
      fetchneighbor: [],
      mapsData: [],
      shelters: [],
      markers: [],
      selectedMarker: null,
      polyGon: [],
      boolWindow: null,
      schoolImage: false,
      selectedtab: "npi",
      singleneighbor: [],
      tabselect: 0,
      getfilterdata: [],
      userdetails: "",
      loggedin: false,
      zooms: 12,
      selectedNeighborhood: "",
      lat: "",
      lng: "",
      rhpmapcords: [],
      loaderdispaly: "none",
    };
  }

  onZoomChanged = () => {
    setTimeout(() => {
      this.bound_changed();
    }, 500);
  };

  bound_changed = () => {
    let zoom_level = this.map.state.map.getZoom();

    let cdata = [];
    this.npiscore = [];
    let cityname = this.city_name_map ? this.city_name_map : "";
    // if(zoom_level < 13){
    //   if(this.homegmarkers.length > 0){
    //     for (var i=0; i<this.homegmarkers.length; i++) {
    //       this.homegmarkers[i].setMap(null);
    //     }
    //   }
    //   this.homegmarkers=[];
    //   this.home_points=[];

    //   for (var i=0; i < this.pbermudaTriangle.length; i++)
    // {
    //   this.pbermudaTriangle[i].setMap(null);
    // }
    // this.polygon_points=[];
    // }
    this.setState({ loaderdispaly: "none" });
    if (zoom_level >= 12) {
      if (this.loadrcount === 0) {
        this.setState({ loaderdispaly: "block" });
      }
      var getdata = {
        start: 0,
        limit: 100,
        order: "DESC",
        orderBy: "npi",
        fields: [{ name: "postalcity_name", value: cityname, operator: "=" }],
      };
      getcitydata(getdata)
        .then((result) => {
          if (result.data.getcitydata.length > 0) {
            this.loadrcount = this.loadrcount + 1;
            this.setState({ loaderdispaly: "none" });
            function getcolor(finalvalue) {
              let value = Math.round(finalvalue);
              let color = "";
              if (parseFloat(value) >= 91 && parseFloat(value) <= 100) {
                color = "#4d6a37";
              } else if (parseFloat(value) >= 81 && parseFloat(value) <= 90) {
                color = "#648d49";
              } else if (parseFloat(value) >= 71 && parseFloat(value) <= 80) {
                color = "#8daa78";
              } else if (parseFloat(value) >= 61 && parseFloat(value) <= 70) {
                color = "#b7d09c";
              } else if (parseFloat(value) >= 51 && parseFloat(value) <= 60) {
                color = "#cfdebe";
              } else if (parseFloat(value) >= 41 && parseFloat(value) <= 50) {
                color = "#f2df90";
              } else if (parseFloat(value) >= 31 && parseFloat(value) <= 40) {
                color = "#f9c467";
              } else if (parseFloat(value) >= 21 && parseFloat(value) <= 30) {
                color = "#ff8b24";
              } else if (parseFloat(value) >= 11 && parseFloat(value) <= 20) {
                color = "#ef4f09";
              } else if (parseFloat(value) >= 1 && parseFloat(value) <= 10) {
                color = "#c62733";
              } else {
                color = "#FFFFFF";
              }

              return color;
            }
            let icons = {
              url: "/static/images/Price2.png",
              scaledSize: new google.maps.Size(35, 25),
              strokeColor: "#FFFFFF",
              origin: new google.maps.Point(0, 0),
              anchor: new google.maps.Point(35, 25),
              labelOrigin: new google.maps.Point(18, 8),
              //fontSize: "8px"
            };
            result.data.getcitydata.map((item, index) => {
              this.npiscore.push(item.npi);
              if (item.geometry_cords) {
                cdata.push(item.geometry_cords);
              }

              cdata.map((item3, index3) => {
                item3.map((item4, index4) => {
                  if (!this.polygon_points.includes(item4)) {
                    this.polygon_points.push(item4);
                    let newdata = JSON.parse(item4);

                    let reversedCoordsnew = newdata.map((item5, index5) => {
                      return {
                        lat: parseFloat(item5.x),
                        lng: parseFloat(item5.y),
                      };
                    });
                    this.bermudaTriangle = new google.maps.Polygon({
                      paths: [reversedCoordsnew],
                      strokeColor: "#FFFFFF",
                      strokeWeight: 1,
                      fillColor: getcolor(this.npiscore[index3]),
                      //fillOpacity: 0.25,
                      zIndex: 2,
                      id: item.id,
                    });

                    google.maps.event.addListener(
                      this.bermudaTriangle,
                      "click",
                      function (event) {
                        window.open(
                          `/Neighborhood/${item.nhfullname}`,
                          "_blank",
                        );
                        //Router.push('/DetailsNh');
                      },
                    );
                    google.maps.event.addListener(
                      this.bermudaTriangle,
                      "mouseover",
                      function (event) {
                        this.setOptions({
                          strokeWeight: 3.6,
                          opacity: 0,
                          zIndex: 2,
                          strokeColor: "#FFFFFF",
                        });
                      },
                    );

                    google.maps.event.addListener(
                      this.bermudaTriangle,
                      "mouseout",
                      function (event) {
                        this.setOptions({
                          strokeWeight: 1,
                          opacity: 0,
                          zIndex: 2,
                          strokeColor: "#FFFFFF",
                        });
                      },
                    );
                    this.bermudaTriangle.setMap(this.map.state.map);
                    this.pbermudaTriangle.push(this.bermudaTriangle);
                  }
                });
              });
              if (item.homes && item.homes.length > 0) {
                item.homes.map((item2, index2) => {
                  if (!this.home_points.includes(item2.lat + item2.lang)) {
                    this.home_points.push(item2.lat + item2.lang);
                    let newloc = {
                      lat: parseFloat(item2.lat),
                      lng: parseFloat(item2.lang),
                    };
                    var marker = new google.maps.Marker({
                      position: newloc,
                      label: {
                        text: `${humanFormat(item2.price, {
                          decimals: item2.price.toString().length < 7 ? 0 : 2,
                        })}`,
                        color: "#fff",
                        fontSize: "12px",
                      },
                      icon: icons,
                      animation: google.maps.Animation.DROP,
                      id: item2.id,
                    });

                    google.maps.event.addListener(
                      marker,
                      "click",
                      function (event) {
                        window.open(`/DetailsListing/?id=${this.id}`, "_blank");
                        //Router.push('/DetailsNh');
                      },
                    );
                    // marker.setMap(this.map.state.map);
                    this.homegmarkers.push(marker);
                  }
                });

                var clusterStyles = [
                  {
                    textColor: "white",
                    url: "/static/images/marker1.png",
                    height: 30,
                    width: 30,
                  },
                  {
                    textColor: "white",
                    url: "/static/images/marker2.png",
                    height: 35,
                    width: 35,
                  },
                  {
                    textColor: "white",
                    url: "/static/images/marker3.png",
                    height: 40,
                    width: 40,
                  },
                ];
                var mcOptions = {
                  gridSize: 200,
                  styles: clusterStyles,
                  maxZoom: 14,
                  // minimumClusterSize: 10
                };
                this.homemarkerCluster = new markerClusterer.MarkerClusterer(
                  this.map.state.map,
                  this.homegmarkers,
                  mcOptions,
                );
              }
            });
          }
        })
        .catch((error) => {
          console.log("error-->", error);
        });
    }
  };

  componentDidMount() {
    // const searchParams = new URLSearchParams(window.location.search);

    this.city_name_map = this.props.cityname;
    this.state_name_map = this.props.statename;
    this.getplolygon(this.city_name_map, this.state_name_map);
    const script = document.createElement("script");
    script.src =
      "https://unpkg.com/@googlemaps/markerclusterer/dist/index.min.js";
    script.async = true;
    document.body.appendChild(script);
  }

  getplolygon = (citydata, statedata) => {
    var geocoder = new google.maps.Geocoder();
    let final_cords = [];
    let that = this;
    var city_name = citydata + "," + statedata;

    if (geocoder) {
      geocoder.geocode({ address: city_name }, function (results, status) {
        let searchaddress = city_name ? city_name.replace(/,[^,]+$/, "%") : "";
        if (
          results &&
          (results[0].types[0] === "locality" ||
            results[0].types[0] === "neighborhood")
        ) {
          var citydata = [];
          axios
            .get(
              `https://nominatim.openstreetmap.org/search.php?q=${city_name}&polygon_geojson=1&format=geojson`,
            )
            .then((res) => {
              if (res.data && res.data.features.length > 0) {
                var result = res.data.features.filter(
                  (number) =>
                    number.geometry.type === "Polygon" ||
                    number.geometry.type === "MultiPolygon" ||
                    number.geometry.type === "FeatureCollection",
                );
                result = result[0];

                var city_info = res.data;

                that.setState({
                  lat: (result.bbox[1] + result.bbox[3]) / 2,
                });
                that.setState({
                  lng: (result.bbox[0] + result.bbox[2]) / 2,
                });

                var id = 0;
                // if (
                //   searchaddress === "Hillsborough, CA%" ||
                //   searchaddress === "Hillsborough CA%" ||
                //   searchaddress === "Hillsborough, California%" ||
                //   searchaddress === "San Mateo%" ||
                //   searchaddress === "San Mateo" ||
                //   searchaddress === "Alameda, CA%" ||
                //   searchaddress === "San Mateo CA%" ||
                //   searchaddress === "San Mateo, CA%" ||
                //   searchaddress === "San Mateo, California%" ||
                //   searchaddress === "Hillsborough" ||
                //   searchaddress === "Hillsborough CA"
                // ) {
                //   id = 1;
                // } else {
                //   if (result.geometry.type === "Point") {
                //     id = 1;
                //   }
                // }
                if (result.geometry.type === "Polygon") {
                  citydata = result.geometry.coordinates[0];
                } else if (result.geometry.type === "MultiPolygon") {
                  var c_length = result.geometry.coordinates.length;
                  citydata = result.geometry.coordinates[0][0];
                }
                window.y = result;
                if (result.geometry.type === "MultiPolygon") {
                  var cities_length = result.geometry.coordinates.length;

                  var multi_city = [];
                  for (var i = 0; i < cities_length; i++) {
                    multi_city.push(
                      result.geometry.coordinates[i][0].map((item, index) => {
                        return {
                          lat: parseFloat(item[1]),
                          lng: parseFloat(item[0]),
                        };
                      }),
                    );
                  }
                  that.bermudaTriangle3 = new google.maps.Polygon({
                    paths: multi_city,
                    strokeWeight: 3.6,
                    strokeColor: "#c02e26",
                    fillOpacity: 0,
                    zIndex: 0,
                    //name: city_info.features[id].properties.display_name,
                  });
                  google.maps.event.addListener(
                    that.bermudaTriangle3,
                    "dblclick",
                    function (event) {
                      window.open(`/City/${that.name}`, "_blank");
                    },
                  );
                  google.maps.event.addListener(
                    that.bermudaTriangle3,
                    "click",
                    function (event) {
                      // window.open(`/City/?name=?${this.name}`,'_blank');
                    },
                  );
                  if (that.map && that.map.state && that.map.state.map) {
                    that.bermudaTriangle3.setMap(that.map.state.map);
                  }
                  // that.bermudaTriangle3.setMap(that.map.state.map);
                  that.citybermudaTrianglesingle.push(that.bermudaTriangle3);
                } else {
                  let city_reservdedata = citydata.map((item5, index5) => {
                    return {
                      lat: parseFloat(item5[1]),
                      lng: parseFloat(item5[0]),
                    };
                  });

                  that.bermudaTriangle3 = new google.maps.Polygon({
                    paths: [city_reservdedata],
                    strokeWeight: 3.6,
                    strokeColor: "#c02e26",
                    fillOpacity: 0,
                    zIndex: 0,
                    name: city_info.features[0].properties.display_name,
                  });
                  google.maps.event.addListener(
                    that.bermudaTriangle3,
                    "dblclick",
                    function (event) {
                      window.open(`/City/${city_name}`, "_blank");
                      //Router.push('/DetailsNh');
                    },
                  );
                  google.maps.event.addListener(
                    that.bermudaTriangle3,
                    "click",
                    function (event) {
                      // window.open(`/City/?name=?${this.name}`,'_blank');
                    },
                  );
                  that.bermudaTriangle3.setMap(that.map.state.map);
                  that.citybermudaTrianglesingle.push(that.bermudaTriangle3);
                }
              }
            });
        }
      });
    }
  };

  render() {
    return (
      <div>
        {this.state.lat !== "" && (
          <Grid>
            <Grid.Row>
              <Grid.Column id="map" style={{ paddingLeft: 0, paddingRight: 0 }}>
                <div style={{ paddingLeft: "12px", paddingRight: "12px" }}>
                  <GoogleMapExample
                    ref={(c) => {
                      this.map = c;
                    }}
                    defaultCenter={{ lat: this.props.lat, lng: this.props.lng }}
                    zoom={11}
                    data={this}
                    // onClick={this.handleClick}
                    // onDragEnd={this.onDragChanged}
                    onZoomChanged={this.onZoomChanged}
                    mapContainerStyle={{
                      height: "300px",
                      width: "100%",
                    }}
                    mapElement={<div style={{ height: "100%" }} />}
                  />
                  <div
                    id="loadingDivcity"
                    className="loading"
                    style={{ display: this.state.loaderdispaly }}
                  >
                    Loading Data...
                  </div>
                </div>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        )}
      </div>
    );
  }
}

export default Bottommap;
